export const BLOG_NOTICE_DEFAULT_TEXTS = ["Novo post", "Confira agora"];
export const BLOG_TEXT_DELAY_MS = 7000;
export const BLOG_TEXT_TYPE_INTERVAL_MS = 90;
export const BLOG_TEXT_HOLD_MS = 4000;
export const BLOG_TEXT_GAP_MS = 10000;
export const BLOG_TEXT_MAX_LENGTH = 20;
export const BLOG_NOTICE_COOLDOWN_MS = 30 * 60 * 1000;
export const BLOG_NOTICE_CONFIG_DOC = "blog_notice";

export const sanitizeBlogNoticeTexts = (texts = []) => {
  if (!Array.isArray(texts)) {
    return [];
  }
  return texts
    .map((text) => String(text ?? "").trim())
    .map((text) => text.slice(0, BLOG_TEXT_MAX_LENGTH))
    .filter((text) => text.length > 0);
};
